import {Axis} from '@visx/xychart';

type Props = React.ComponentProps<typeof Axis> & {
  key: string;
};
export function LineChartAxis(props: Props): React.JSX.Element {
  return (
    <Axis
      {...props}
      axisClassName="*:stroke-slate7"
      stroke={undefined}
      tickClassName="*:stroke-slate6"
      tickStroke={undefined}
      tickLabelProps={{
        className: 'fill-slate12 text-xs/3 font-sans font-semibold',
        // visx sets these, but we override them
        fill: undefined,
        fontFamily: undefined,
        fontSize: undefined,
        fontWeight: undefined,
      }}
    />
  );
}
